import { isPresent, isNotEmpty } from "neetocist";
import { __, all, curry, equals, includes, is } from "ramda";

export const isSubRouteActive = (subRoute, location) => {
  const currentBrowserUrl = new URL(
    location.pathname + location.search + location.hash,
    window.location.origin
  );
  const targetUrl = new URL(subRoute, window.location.origin);

  const targetSearchParams = targetUrl.searchParams;
  const targetSearchKeys = Array.from(targetSearchParams.keys());

  return (
    all(
      key =>
        currentBrowserUrl.searchParams.get(key) === targetSearchParams.get(key),
      targetSearchKeys
    ) && equals(currentBrowserUrl.pathname, targetUrl.pathname)
  );
};

export const getSidebarStateLocalStorageKey = () => {
  const user = globalProps.user?.email || globalProps.user?.phoneNumber;

  return `sidebarState-${user}`;
};

export const filterByPermissions = curry(({ permissions }) => {
  if (permissions && isNotEmpty(permissions)) {
    return is(Array, permissions)
      ? permissions.some(includes(__, globalProps.permissions))
      : globalProps.permissions.includes(permissions);
  }

  return true;
});

export const getActiveConfigurePageLink = ({ navLinks, location }) =>
  navLinks.find(link => {
    const [linkPathname] = link.to?.split("?") || [];

    return (
      isPresent(link.isConfigureNavLink) &&
      link.isConfigureNavLink &&
      location.pathname.startsWith(linkPathname)
    );
  });

export const enableDraggingStyles = () => {
  document.body.classList.add("dragging-sidebar");
  document.body.style.cursor = "col-resize";
  document.body.style.userSelect = "none";
};

export const disableDraggingStyles = () => {
  document.body.classList.remove("dragging-sidebar");
  document.body.style.cursor = "";
  document.body.style.userSelect = "";
};
